<form [formGroup]="form.formGroup">
  <div class="flex flex-col space-y-2">
    <app-uom-input
      label="Fracture Depth"
      [unitLabel]="userUnits.longLengths + ' MD'"
      [formControlName]="form.formControlNames.fractureDepth"
      [control]="'fractureDepth'"
      [default]="influxDepthRange.min"
      [min]="influxDepthRange.min"
      [max]="influxDepthRange.max"
      title="Allowed range: {{ influxDepthRange.min }} - {{ influxDepthRange.max }} {{ userUnits.longLengths }}"
      (focusout)="fractureDepthChange()"
    />
    

    <app-uom-input
      label="Fluid Density"
      [unitLabel]="densityLabel"
      [formControlName]="form.formControlNames.fluidDensity"
      [control]="'fluidDensity'"
      [min]="densityValidation.min"
      [max]="densityValidation.max"
      title="Allowed range: {{ densityValidation.min }} - {{ densityValidation.max }} {{ densityLabel }}"
    />

    <app-uom-input
      label="Fracture Gradient"
      [unitLabel]="densityLabel"
      [formControlName]="form.formControlNames.fractureGradient"
      [control]="'fractureGradient'"
      [default]="defaultFracGradient"
      [min]="fractureGradientValidation.min"
      [max]="fractureGradientValidation.max"
      title="Allowed range: {{ fractureGradientValidation.min }} - {{ fractureGradientValidation.max }} {{ densityLabel }}"
      (focusout)="fractureGradientChange()"
    />

    <app-uom-input
      label="Fracture Margin"
      [unitLabel]="densityLabel"
      [formControlName]="form.formControlNames.fractureMargin"
      [control]="'fractureMargin'"
      [default]="'0'"
      [min]="marginOfErrorValidation.min"
      [max]="marginOfErrorValidation.max"
      title="Allowed range: {{ marginOfErrorValidation.min }} - {{ marginOfErrorValidation.max }} {{ densityLabel }}"
    />
  </div>
</form>
